import { Grid, GridDirection } from "@mui/material";
import React from "react";

interface ISplitContentBlockProps {
  children: [React.ReactNode, React.ReactNode];
  direction?: GridDirection;
  gap?: string | undefined;
  paddingTop?: string | undefined;
}

/**
 * Will split it's area in two equal parts, and display two children
 * equally with space between.
 * @param param0
 * @returns
 */
const SplitContentBlock: React.FC<ISplitContentBlockProps> = ({
  direction = "row",
  children,
  gap,
  paddingTop,
}: ISplitContentBlockProps) => {
  return (
    <Grid
      container
      direction={direction}
      paddingTop={paddingTop}
      gap={gap}
      justifyContent="center"
      alignItems="stretch"
    >
      <Grid item md={6}>
        {children[0]}
      </Grid>
      <Grid item md={6} display="flex" alignItems="center">
        {children[1]}
      </Grid>
    </Grid>
  );
};
export default SplitContentBlock;
